import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {EmployeeInvitationConfirmationComponent} from './employee-invitation-confirmation/employee-invitation-confirmation.component';
import {HomeComponent} from './home/home.component';
import {CooperationInvitationResponseComponent} from './cooperation-invitation-response/cooperation-invitation-response.component';

const routes: Routes = [
  {path: 'employee-invitation-confirmation', component: EmployeeInvitationConfirmationComponent},
  {path: 'cooperation-invitation-response', component: CooperationInvitationResponseComponent},
  {
    path: '', component: HomeComponent, children: [
      {path: 'lead-form', loadChildren: () => import('./lead-form-app/lead-form-app.module').then(m => m.LeadFormAppModule)},
      {path: 'tools', loadChildren: () => import('./tools/tools.module').then(m => m.ToolsModule)},
      {path: 'content-modules', loadChildren: () => import('./content-modules/content-modules.module').then(m => m.ContentModulesModule)},
      {path: 'history', loadChildren: () => import('./history/history.module').then(m => m.HistoryModule)},
      {path: 'support', loadChildren: () => import('./support/support.module').then(m => m.SupportModule)},
      {path: '**', redirectTo: 'lead-form'}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
